import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { CorretorService } from '../services/corretor.service'; // ajuste o caminho conforme necessário
import { CorretorResposneDto } from '../dto/corretor-response.dto';

@Injectable({
   providedIn: 'root'
})
export class CorretorExisteGuard implements CanActivate {
   constructor(private corretorService: CorretorService, private router: Router) {}

   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
      const idParam = route.paramMap.get('idC');
      const id = Number(idParam); // converte para número

      // Se não for um número válido, redireciona para home
      if (!id || isNaN(id)) {
         return this.router.createUrlTree(['/']);
      }

      try {
         const corretor: CorretorResposneDto | undefined = await this.corretorService.getCorretorByCodigo(id);
         if (corretor) {
            return true;
         } else {
            return this.router.createUrlTree(['/']);
         }
      } catch (e) {
         return this.router.createUrlTree(['/']);
      }
   }
}
